/* ============================================================
   MYNA - cart enhancements + account state
   v8: Profile icon -> GoKwik KwikPass OTP only.
       Single kp_trigger_popup(false) call — no extra args.
       Waits for GoKwik iframe ready before triggering.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.MYNA_LOGIN_CONFIG || { backend: '', demo: true, accountUrl: '/account', ordersUrl: '/account' };
  var AUTH_KEY = 'myna_auth';
  var overlay = document.getElementById('myna-login-overlay');
  if (!overlay) return;

  var $ = function (id) { return document.getElementById(id); };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  function getAuth() { try { return JSON.parse(localStorage.getItem(AUTH_KEY) || 'null'); } catch (e) { return null; } }
  function setAuth(a) { try { localStorage.setItem(AUTH_KEY, JSON.stringify(a)); } catch (e) {} window.mynaCustomer={loggedIn:true,name:a&&a.name,phone:a&&a.phone}; window.dispatchEvent(new CustomEvent('myna:loggedin',{detail:a})); renderAccount(); }
  function clearAuth() { try { localStorage.removeItem(AUTH_KEY); } catch (e) {} window.mynaCustomer={loggedIn:false}; renderAccount(); }
  function loggedIn() { var a = getAuth(); return !!(a && a.phone); }
  function firstName() { var a = getAuth(); return a && a.name ? a.name.trim().split(/\s+/)[0] : ''; }

  function api(path, body) {
    return fetch((CFG.backend || '') + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }
  function requestOTP(phone) {
    if (CFG.demo) return wait(650).then(function () { return { ok: true }; });
    return api('/api/auth', { action: 'send-otp', phone: phone });
  }
  function verifyOTP(phone, code) {
    if (CFG.demo) {
      return wait(700).then(function () {
        if (code === '000000') return { ok: false };
        var known = getAuth();
        var isNew = !(known && known.phone === phone);
        return { ok: true, isNewUser: isNew, token: 'demo-' + Date.now(), profile: known && known.phone === phone ? known : { phone: phone } };
      });
    }
    return api('/api/auth', { action: 'verify-otp', phone: phone, code: code });
  }
  function saveProfile(data) {
    if (CFG.demo) return wait(600).then(function () { return { ok: true, profile: data }; });
    return api('/api/auth', { action: 'profile', token: data.token, phone: data.phone, name: data.name, email: data.email, whatsapp: data.whatsapp });
  }

  /* ---------- modal (used by cart Log-in button only) ---------- */
  var panels = { phone: $('mynaPPhone'), otp: $('mynaPOtp'), name: $('mynaPName'), done: $('mynaPDone') };
  var dots = $('mynaLgDots'), back = $('mynaLgBack');
  var cur = 'phone', timerId = null, lastFocus = null, currentPhone = '';

  function show(step) {
    Object.keys(panels).forEach(function (k) { panels[k].classList.remove('active'); });
    panels[step].classList.add('active'); cur = step;
    var idx = { phone: 0, otp: 1, name: 2 }[step];
    if (step === 'done') { dots.classList.add('hide'); }
    else { dots.classList.remove('hide'); [].forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i <= idx); }); }
    back.classList.toggle('show', step === 'otp' || step === 'name');
    var f = panels[step].querySelector('input:not([type=checkbox])');
    if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 320);
  }

  function openModal() { lastFocus = document.activeElement; overlay.classList.add('open'); overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; resetForms(); show('phone'); }
  function closeModal() { overlay.classList.remove('open'); overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; clearInterval(timerId); if (lastFocus) try { lastFocus.focus(); } catch (e) {} }

  function resetForms() {
    $('mynaPhoneNum').value = ''; $('mynaFPhone').classList.remove('err'); $('mynaEPhone').classList.remove('show');
    boxes.forEach(function (x) { x.value = ''; x.classList.remove('filled'); });
    $('mynaOtpBoxes').classList.remove('err'); $('mynaEOtp').classList.remove('show');
    var n = $('mynaNameIn'), em = $('mynaEmailIn'); if (n) n.value = ''; if (em) em.value = '';
  }

  $('mynaLgClose').addEventListener('click', closeModal);
  overlay.addEventListener('mousedown', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('open')) closeModal(); });
  back.addEventListener('click', function () { if (cur === 'otp') show('phone'); else if (cur === 'name') show('otp'); });

  var phoneNum = $('mynaPhoneNum'), phoneCode = $('mynaPhoneCode');
  phoneNum.addEventListener('input', function () { phoneNum.value = phoneNum.value.replace(/\D/g, ''); $('mynaFPhone').classList.remove('err'); $('mynaEPhone').classList.remove('show'); });
  phoneNum.addEventListener('keydown', function (e) { if (e.key === 'Enter') $('mynaBtnPhone').click(); });
  $('mynaBtnPhone').addEventListener('click', function () {
    var digits = phoneNum.value.trim();
    if (digits.length < 10) { $('mynaFPhone').classList.add('err'); $('mynaEPhone').classList.add('show'); return; }
    currentPhone = phoneCode.value + digits;
    $('mynaOtpNum').textContent = phoneCode.value + ' ' + digits.replace(/(\d{5})(\d{5})/, '$1 $2');
    var b = $('mynaBtnPhone'); b.querySelector('.t').textContent = 'Sending...'; b.setAttribute('disabled', '');
    requestOTP(currentPhone).then(function () {
      b.querySelector('.t').textContent = 'Continue'; b.removeAttribute('disabled');
      show('otp'); startTimer();
    });
  });

  var boxes = [].slice.call(document.querySelectorAll('#mynaOtpBoxes input'));
  boxes.forEach(function (b, i) {
    b.addEventListener('input', function () {
      b.value = b.value.replace(/\D/g, '').slice(0, 1);
      b.classList.toggle('filled', !!b.value);
      $('mynaOtpBoxes').classList.remove('err'); $('mynaEOtp').classList.remove('show');
      if (b.value && i < 5) boxes[i + 1].focus();
      if (boxes.every(function (x) { return x.value; })) verify();
    });
    b.addEventListener('keydown', function (e) { if (e.key === 'Backspace' && !b.value && i > 0) boxes[i - 1].focus(); });
  });
  $('mynaOtpBoxes').addEventListener('paste', function (e) {
    e.preventDefault();
    var d = ((e.clipboardData || window.clipboardData).getData('text') || '').replace(/\D/g, '').slice(0, 6).split('');
    boxes.forEach(function (x, i) { x.value = d[i] || ''; x.classList.toggle('filled', !!x.value); });
    (boxes[d.length] || boxes[5]).focus(); if (d.length === 6) verify();
  });
  function codeVal() { return boxes.map(function (x) { return x.value; }).join(''); }
  $('mynaBtnOtp').addEventListener('click', verify);
  $('mynaOtpChange').addEventListener('click', function () { show('phone'); });

  function verify() {
    if (codeVal().length < 6) { $('mynaOtpBoxes').classList.add('err'); $('mynaEOtp').textContent = 'Please enter all 6 digits'; $('mynaEOtp').classList.add('show'); return; }
    var b = $('mynaBtnOtp'); b.querySelector('.t').textContent = 'Verifying...'; b.setAttribute('disabled', '');
    verifyOTP(currentPhone, codeVal()).then(function (res) {
      b.querySelector('.t').textContent = 'Verify & Continue'; b.removeAttribute('disabled');
      if (!res || !res.ok) {
        $('mynaOtpBoxes').classList.add('err'); $('mynaEOtp').textContent = (res && res.error) || "That code doesn't match. Try again."; $('mynaEOtp').classList.add('show');
        boxes.forEach(function (x) { x.value = ''; x.classList.remove('filled'); }); boxes[0].focus(); return;
      }
      clearInterval(timerId);
      var prof = res.profile || {};
      var existing = getAuth() || {};
      var merged = { token: res.token || existing.token || 'session', phone: currentPhone, name: prof.name || existing.name || '', email: prof.email || existing.email || '' };
      setAuth(merged);
      finishDone(res.isNewUser ? 'Welcome to MYNA!' : 'Welcome back' + (merged.name ? ', ' + merged.name.split(/\s+/)[0] : '') + '.');
    });
  }

  var resend = $('mynaResend');
  function startTimer() {
    var t = 30; resend.innerHTML = '<span class="rs">Resend code in <b id="mynaTimer">0:30</b></span>';
    var tm = $('mynaTimer'); clearInterval(timerId);
    timerId = setInterval(function () {
      t--; if (tm) tm.textContent = '0:' + String(Math.max(t, 0)).padStart(2, '0');
      if (t <= 0) {
        clearInterval(timerId);
        resend.innerHTML = "Didn't get it? <span class=\"go\" id=\"mynaRGo\">Resend code</span>";
        var g = $('mynaRGo'); if (g) g.addEventListener('click', function () { boxes.forEach(function (x) { x.value = ''; x.classList.remove('filled'); }); boxes[0].focus(); requestOTP(currentPhone); startTimer(); });
      }
    }, 1000);
  }

  $('mynaNameIn').addEventListener('input', function () { $('mynaFName').classList.remove('err'); $('mynaEName').classList.remove('show'); });
  $('mynaBtnName').addEventListener('click', function () {
    var name = $('mynaNameIn').value.trim();
    if (!name) { $('mynaFName').classList.add('err'); $('mynaEName').classList.add('show'); return; }
    var email = $('mynaEmailIn').value.trim(), wa = $('mynaWaOpt').checked;
    var auth = getAuth() || {};
    var b = $('mynaBtnName'); b.querySelector('.t').textContent = 'Saving...'; b.setAttribute('disabled', '');
    saveProfile({ token: auth.token, phone: currentPhone, name: name, email: email, whatsapp: wa }).then(function (res) {
      b.querySelector('.t').textContent = 'Finish'; b.removeAttribute('disabled');
      var prof = (res && res.profile) || {};
      setAuth({ token: auth.token || 'session', phone: currentPhone, name: prof.name || name, email: prof.email || email });
      finishDone('Welcome to MYNA, ' + name.split(/\s+/)[0] + '. Your account is ready.');
    });
  });

  function finishDone(msg) { $('mynaDoneMsg').textContent = msg; show('done'); }
  $('mynaBtnDone').addEventListener('click', closeModal);

  /* ---------- account dropdown (for MYNA-logged-in users) ---------- */
  var menuEl = null;
  function buildMenu() {
    if (menuEl) return menuEl;
    menuEl = document.createElement('div');
    menuEl.className = 'myna-acct-menu';
    document.body.appendChild(menuEl);
    menuEl.addEventListener('click', function (e) {
      var lo = e.target.closest('.myna-logout'); if (lo) { e.preventDefault(); closeMenu(); clearAuth(); }
    });
    return menuEl;
  }
  function closeMenu() {
    if (!menuEl) return;
    menuEl.classList.remove('open');
    var a = menuEl._anchor; if (a) { var c = a.querySelector('.myna-acct-caret'); if (c) c.classList.remove('open'); }
  }
  function maskPhone(p) {
    var digits = String(p || '').replace(/\D/g, '');
    if (digits.length <= 3) return digits ? '+' + digits : '';
    var cc = digits.length > 10 ? digits.slice(0, digits.length - 10) : '';
    var nat = digits.length > 10 ? digits.slice(-10) : digits;
    var last = nat.slice(-3);
    var masked = new Array(Math.max(nat.length - 3, 0) + 1).join('-');
    var mid = masked.length > 5 ? masked.slice(0, 5) + ' ' + masked.slice(5) : masked;
    return (cc ? '+' + cc + ' ' : '') + mid + last;
  }
  function openMenu(anchor) {
    var m = buildMenu(); var a = getAuth() || {};
    m.innerHTML =
      '<div class="myna-acct-menu-head"><div class="myna-acct-menu-hi">Hi, <em>' + esc(firstName()) + '</em></div>' +
      (a.phone ? '<div class="myna-acct-menu-ph">' + esc(maskPhone(a.phone)) + '</div>' : '') + '</div>' +
      '<a href="' + esc(CFG.accountUrl || '/account') + '"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0116 0"/></svg>My Account</a>' +
      '<a href="' + esc(CFG.ordersUrl || '/account') + '"><svg viewBox="0 0 24 24"><path d="M6 2l1.2 3M18 2l-1.2 3M4 7h16l-1 13H5L4 7z"/><path d="M9 11a3 3 0 006 0"/></svg>My Orders</a>' +
      '<div class="myna-acct-menu-div"></div>' +
      '<button type="button" class="myna-logout"><svg viewBox="0 0 24 24"><path d="M16 17l5-5-5-5M21 12H9M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/></svg>Sign Out</button>';
    var r = anchor.getBoundingClientRect();
    m.style.position = 'fixed';
    m.style.top = (r.bottom + 10) + 'px';
    m.style.right = Math.max(8, (window.innerWidth - r.right)) + 'px';
    m.classList.add('open'); m._anchor = anchor;
    var caret = anchor.querySelector('.myna-acct-caret'); if (caret) caret.classList.add('open');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function accountLinks() {
    return [].slice.call(document.querySelectorAll('a[aria-label^="Account"], .alk-mobile-drawer-account, [data-myna-account]'));
  }
  function renderAccount() {
    var name = firstName();
    accountLinks().forEach(function (link) {
      var isMobile = link.classList.contains('alk-mobile-drawer-account');
      var existing = link.querySelector('.myna-acct-name');
      var caret = link.querySelector('.myna-acct-caret');
      if (loggedIn()) {
        if (!isMobile) {
          if (!existing) { var span = document.createElement('span'); span.className = 'myna-acct-name'; span.textContent = name || 'You'; link.appendChild(span); }
          else existing.textContent = name || 'You';
          if (!caret) { var c = document.createElement('span'); c.className = 'myna-acct-caret'; c.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>'; link.appendChild(c); }
          link.classList.add('myna-acct-live');
        }
        link.setAttribute('aria-label', 'Account' + (name ? ' - ' + name : ''));
      } else {
        if (existing) existing.remove(); if (caret) caret.remove();
        link.classList.remove('myna-acct-live');
        link.setAttribute('aria-label', 'Account');
      }
    });
  }

  /* =============================================================
     PROFILE ICON CLICK -> GoKwik KwikPass OTP

     KEY FIX (v8): Only call kp_trigger_popup(false) — ONE call.
     Calling kp_trigger_popup(true) causes checkout navigation
     which reloaded the page on first click. Removed.

     Also waits for GoKwik iframe to be ready before triggering.
     ============================================================= */

  function triggerKwikPass() {
    /* Wait until GoKwik's iframe is loaded before showing popup.
       IS_KP_IFRAME_LOADED becomes true when GoKwik is ready.
       Poll up to 3 seconds (60 × 50ms). */
    if (window.kp_trigger_popup && window.IS_KP_IFRAME_LOADED) {
      try { window.kp_trigger_popup(false); } catch (_) {}
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (window.kp_trigger_popup && window.IS_KP_IFRAME_LOADED) {
        clearInterval(timer);
        try { window.kp_trigger_popup(false); } catch (_) {}
      } else if (attempts >= 60) {
        clearInterval(timer);
        /* Last resort: try anyway even if iframe flag not set */
        if (window.kp_trigger_popup) {
          try { window.kp_trigger_popup(false); } catch (_) {}
        }
      }
    }, 50);
  }

  window.addEventListener('click', function (e) {
    var acct = e.target.closest('a[aria-label^="Account"], .alk-mobile-drawer-account, [data-myna-account]');
    if (!acct) return;

    /* Block navigation and all other handlers */
    e.preventDefault();
    e.stopImmediatePropagation();

    if (loggedIn()) {
      /* MYNA session active — show dropdown */
      if (menuEl && menuEl.classList.contains('open')) closeMenu();
      else openMenu(acct);
      return;
    }

    /* Save return URL so patches.js can bounce back from /pages/kp-account */
    try { sessionStorage.setItem('myna_pre_login_url', window.location.href); } catch (_) {}

    /* Trigger GoKwik KwikPass login OTP — single call with false */
    triggerKwikPass();

  }, true /* CAPTURE phase at window level */);

  /* Close account menu on outside click */
  document.addEventListener('click', function (e) {
    if (menuEl && menuEl.classList.contains('open') && !e.target.closest('.myna-acct-menu')) closeMenu();
  });
  window.addEventListener('resize', closeMenu);

  /* Expose */
  window.mynaCustomer = { loggedIn: loggedIn(), name: firstName(), phone: (getAuth() || {}).phone };
  window.MYNA = window.MYNA || {};
  window.MYNA.openLogin = openModal; /* cart button still uses this */
  window.MYNA.logout = clearAuth;
  window.MYNA.isLoggedIn = loggedIn;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAccount);
  else renderAccount();

})();
